import { render, staticRenderFns } from "./WidgetFilters.vue?vue&type=template&id=b008e602&"
import script from "./WidgetFilters.vue?vue&type=script&lang=js&"
export * from "./WidgetFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports